import type { ReactNode } from 'react';
import React, { forwardRef, useRef } from 'react';

import { Box } from '@mui/material';

import { PlusCircleIcon, PlusCircleOutlinedIcon, PlusIcon } from '@setup/svg-icons/svg-icons';
import useHover from '@shared/hooks/useHover';

import { MuiCustomFabButton } from './MuiFloatButton.style';

import type { FabProps } from '@mui/material';

type MuiFloatButtonPropsType = {
  icon?: ReactNode;
  isDisabled?: boolean;
} & Partial<FabProps>;
export const MuiFloatButton = forwardRef<HTMLButtonElement, MuiFloatButtonPropsType>((props, ref) => {
  const { icon, isDisabled, size = 'medium', ...restProps } = props;

  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);

  const smallIcon = (
    <Box width="20px" height="20px" ref={hoverRef}>
      {isHover ? <PlusCircleIcon /> : <PlusCircleOutlinedIcon />}
    </Box>
  );

  const fabIcon = size === 'small' ? smallIcon : icon || <PlusIcon />;
  return (
    <MuiCustomFabButton disabled={isDisabled} {...restProps} ref={ref} size={size}>
      {fabIcon}
    </MuiCustomFabButton>
  );
});
